import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToTiffConfig } from '@/data/landingConfig/landingImageToTiffConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToTiff } from './schemaObject';

interface Props {}
const ImageToTiffConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToTiff} />
			<LandingTemplate
				data={landingImageToTiffConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default ImageToTiffConverter;
